import { Link } from "react-router-dom";
import { SMASH_IMAGES } from "@/lib/assets";
import { SPORTS } from "@/lib/content";

const ACCENT = {
  football: "text-red-500",
  basketball: "text-orange-500",
  baseball: "text-red-400",
  soccer: "text-emerald-400",
  hockey: "text-sky-400",
  boxing: "text-rose-500",
  mma: "text-amber-500",
};

export default function SportIconRow() {
  return (
    <div data-testid="choose-sport-row">
      <p className="text-center font-heading font-bold tracking-[0.25em] text-smasher-gold text-sm mb-4">
        CHOOSE YOUR SPORT
      </p>
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-3 sm:gap-4">
        {SPORTS.map((s) => (
          <Link
            key={s.key}
            to={`/${s.key}`}
            className="group flex flex-col items-center gap-2"
            data-testid={`sport-tile-${s.key}`}
          >
            <div className="w-full aspect-square rounded-2xl overflow-hidden panel panel-hover bg-black/40">
              <img
                src={SMASH_IMAGES[s.key]}
                alt={`Smasher hammer smashing ${s.label}`}
                loading="lazy"
                className="w-full h-full object-cover sport-badge"
              />
            </div>
            <span className={`font-heading font-bold text-xs sm:text-sm tracking-wide ${ACCENT[s.key]} group-hover:brightness-125`}>
              {s.label.toUpperCase()}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
